import { uniqueId } from 'lodash';

import { publicEnv } from '@/lib/env';
import { DivisionTypes, NumDivisionTypes } from '@/types/aprRankings.types';

export const PROFILE_DIVISION_TYPES = [
  {
    id: uniqueId(),
    title: 'Doubles',
    value: 'Doubles',
    femaleType: '4',
    maleType: '5',
  },
  {
    id: uniqueId(),
    title: 'Mixed',
    value: 'Mixed',
    femaleType: '3',
    maleType: '3',
  },
  {
    id: uniqueId(),
    title: 'Singles',
    value: 'Singles',
    femaleType: '1',
    maleType: '2',
  },
];

export const PROFILE_DIVISION_TYPES_WITH_WORLD = [
  {
    id: uniqueId(),
    title: 'World Ranking',
    value: 'world',
    femaleType: null,
    maleType: null,
  },
  {
    id: uniqueId(),
    title: '52 Weeks Doubles',
    value: 'Doubles',
    femaleType: '4',
    maleType: '5',
  },
  {
    id: uniqueId(),
    title: '52 Weeks Mixed',
    value: 'Mixed',
    femaleType: '3',
    maleType: '3',
  },
  {
    id: uniqueId(),
    title: '52 Weeks Singles',
    value: 'Singles',
    femaleType: '1',
    maleType: '2',
  },
];

export const RANK_HISTORY_DIVISION_TYPES = [
  {
    id: uniqueId(),
    title: 'Doubles results (50%)',
    value: 'Doubles',
    femaleType: '4',
    maleType: '5',
  },
  {
    id: uniqueId(),
    title: 'Mixed results (35%)',
    value: 'Mixed',
    femaleType: '3',
    maleType: '3',
  },
  {
    id: uniqueId(),
    title: 'Singles results (15%)',
    value: 'Singles',
    femaleType: '1',
    maleType: '2',
  },
];

export const defaultProfileImage = `${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global/legacy/profile-image.svg`;

export const RANK_HISTORY_PAGE_SIZE = 12;

export enum RANK_HISTORY_TOURNAMENTS_FILTER {
  TOP_5_TOURNAMENTS = 'top',
  OTHER_TOURNAMENTS = 'other',
}

export const FIRST_FOUR_PLAYER_PLACEMENTS = ['1', '2', '3', '4'];

export const TOURNAMENT_DIVISION_TYPES: Record<NumDivisionTypes, DivisionTypes> = {
  '5': 'Mens Doubles',
  '4': 'Womens Doubles',
  '3': 'Mixed Doubles',
  '1': 'Womens Singles',
  '2': 'Mens Singles',
};

//Gauge chart constants
export const DEFAULT_THEME_COLOR = '#3D860A';
export const DEFAULT_DARK_THEME_COLOR = '#306B08';
export const STRENGTH_MODAL_BACKGROUND_COLOR = '#F1F8EC';
export const DEFAULT_NUM_LEVELS = 22;
export const LIGHTEN_FACTOR = 0.7;
export const EMPTY_COLOR_PRIMARY = '#E5E7EB';
export const WHITE_COLOR = '#FFFFFF';
export const DEFAULT_HEIGHT = 120;
export const DEFAULT_WIDTH = 210;
export const NEEDLE_DEFAULT_COLOR = '#181D27';
export const BACKGROUND_ARC_START_COLOR = '#F5F5F5';
export const BACKGROUND_ARC_STOP_COLOR = '#9EC284';

export const DIVISION_TYPES_NUMBERS = ['1', '2', '3', '4', '5', '6', '7'] as const;
export const DIVISION_TYPE_MESSAGE = "divisionType must be a string between '1' and '7'";
export const STATS_TYPE_MESSAGE = "statsType must be a string between '1' and '7'";

/** Panel gradient behind the ranking donut, shared by the APR profile page and the dashboard widget. */
export const APR_PANEL_GRADIENT_CLASS =
  'bg-[image:linear-gradient(260deg,#EAECF0_17.66%,#E6EFE0_79.77%)]';

export const APR_DONUT_CHART_COLORS = {
  doubles: '#245006',
  singles: '#9EC284',
  mixed: '#559528',
} as const;

export const DIVISION_TYPE_LABELS = {
  singles: 'Singles',
  doubles: 'Doubles',
  mixed: 'Mixed',
} as const;
